import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    async beforeEnter (to, from, next) {
      try {
        await axios.get('/api/admin')

        next('/dashboard/users')
      } catch {
        next('/login')
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
    async beforeEnter (to, from, next) {
      try {
        await axios.get('/api/admin')

        next('/dashboard/users')
      } catch {
        next()
      }
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "login" */ '@/views/dashboard.vue'),
    async beforeEnter (to, from, next) {
      try {
        const { data: response } = await axios.get('/api/admin')

        window.$STORE.username = response.username

        next()
      } catch {
        next('/login')
      }
    },
    children: [
      {
        path: 'users',
        name: 'dashboard/users',
        component: () => import(/* webpackChunkName: "dashboard/users" */ '@/views/dashboard/users.vue')
      },
      {
        path: 'user/:identity',
        name: 'dashboard/user',
        props: true,
        component: () => import(/* webpackChunkName: "dashboard/user" */ '@/views/dashboard/user.vue')
      },
      {
        path: 'offline-users',
        name: 'dashboard/offline-users',
        component: () => import(/* webpackChunkName: "dashboard/offline-users" */ '@/views/dashboard/offline-users.vue')
      },
      {
        path: 'admins',
        name: 'dashboard/admins',
        component: () => import(/* webpackChunkName: "dashboard/admins" */ '@/views/dashboard/admins.vue')
      },
      {
        path: 'self',
        name: 'dashboard/self',
        component: () => import(/* webpackChunkName: "dashboard/self" */ '@/views/dashboard/self.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
